import { TextFieldProps } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import React from "react";
import { Control, Controller } from "react-hook-form";

type RHFDatePickerProps = {
  name: string;
  label: string;
  control: Control<any>;
  textFieldProps?: TextFieldProps;
  disabled?: boolean;
};

export const RHFDatePicker: React.FC<RHFDatePickerProps> = ({
  name,
  label,
  control,
  textFieldProps,
  disabled = false,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <DatePicker
          label={label}
          value={field.value ? new Date(field.value) : null}
          onChange={(date: Date | null) => field.onChange(date)}
          disabled={disabled}
          slotProps={{
            textField: {
              ...textFieldProps,
              label,
              fullWidth: true,
            },
          }}
        />
      )}
    />
  );
};
